module.exports = __webpack_public_path__ + "media/images/icon_sort_btn_date2-4f4862ded1c5287977f14af0a81bf5f8.png";